<template>
  <v-dialog v-model="dialog" max-width="950" persistent>
    <v-card>
      <v-card-title>
        <h1 class="title">Selecciona un Plan</h1>
        <v-spacer></v-spacer>
        <v-icon @click="dialog = false">close</v-icon>
      </v-card-title>
      <v-alert type="info" color="secondary" :value="true" v-if="currentSubscription && Number(currentSubscription.status) === 2">
        Al cambiar de plan perderás tus días de prueba
      </v-alert>
      <v-card-text>
        <v-progress-linear v-if="loading" height="2" color="primary" indeterminate />
        <carousel
            v-else paginationColor="black" paginationActiveColor="blue"
            :perPageCustom="[[320, 1], [680, 2], [990, 3]]">
          <slide v-for="plan in plans" :key="plan.id" class="pa-2">
            <plan-card
                :allow-resubscribe="currentSubscription && Number(currentSubscription.status) !== 1 && Number(currentSubscription.status) !== 2"
                :plan="plan"
                :current-plan="subscribedPlan && plan.id === subscribedPlan.id"
                @click:purchase="onPlanPurchase"
            />
          </slide>
        </carousel>
      </v-card-text>
    </v-card>
    <kimsa-confirm
        :persistent="true"
        ref="confirmPurchaseDialog"
        title="Contratar Plan"
        :content="purchaseMessage"
        :loading="loadingPurchase"
        @confirm="planPurchaseConfirm"
        :close-on-confirm="false"
    />
  </v-dialog>
</template>

<script>

import PlanCard from "../admin/plans/PlanCard";
import { Carousel, Slide } from 'vue-carousel';

import {ApiUtils} from "../../utils/ApiUtils";
import KimsaConfirm from "../common/KimsaConfirm";
import {mapGetters} from 'vuex'

export default {
  name: "PlanPicker",
  components: {
    KimsaConfirm,
    PlanCard,
    Carousel,
    Slide
  },
  props: {},
  data(){
    return {
      dialog: false,
      planToPurchase: null,
      loading: false,
      loadingPurchase: false,
      plans: []
    }
  },
  computed:{
    ...mapGetters(['currentSubscription', 'subscribedPlan']),
    purchaseMessage(){
      const vm = this
      if(!vm.planToPurchase) return ''
      const  {amount, trial_period_days} = vm.planToPurchase
      let msg = `Al confirmar,`
      if(trial_period_days && !vm.currentSubscription){
        msg += ` obtendrás <b>${trial_period_days} días adicionales de prueba</b>, una vez transcurrido este período,`
      }
      msg += ` nos autorizas a realizar cobros mensuales por un monto de <b>${amount}UF</b>. ¿Deseas confirmar?`
      return msg;
    },
  },
  created(){
    const vm = this
    vm.getAvailablePlans()
  },
  methods:{
    show(){
      const vm = this
      vm.dialog = true
    },
    hide(){
      const vm = this
      vm.dialog = false
    },
    onPlanPurchase(plan){
      const vm = this
      vm.planToPurchase = plan
      vm.$refs.confirmPurchaseDialog.show()
    },
    async planPurchaseConfirm(){
      const vm = this
      if(!vm.currentProvider || !vm.planToPurchase) return

      vm.loadingPurchase = true
      const response = await ApiUtils.makePost(
          `providers/${vm.currentProvider.id}/subscription/subscribe/${vm.planToPurchase.id}`
      );

      if(!response.ok){
        vm.loadingPurchase = false
        const json = await response.json()
        return vm.toast(json.message || 'Ocurrió un error contratando el plan', 'error')
      }

      const json = await response.json()
      const {result} = json

      if(result.status_code === 'credit_card_needed'){
        return vm.goToCardRegistration()
      }

      vm.planToPurchase = null
      vm.$refs.confirmPurchaseDialog.hide()
      vm.$emit('plan:purchased')
      vm.hide()
      vm.loadingPurchase = false
    },
    async goToCardRegistration(){

      const vm = this
      if(!vm.currentProvider || !vm.planToPurchase) return

      const response = await ApiUtils.makeGet(
          `providers/${vm.currentProvider.id}/subscription/card-registration/${vm.planToPurchase.id}`
      )

      if(!response.ok){
        const json = await response.json()
        vm.toast(json.message || 'Ocurrió un error contratando el plan', 'error')
        return vm.loadingPurchase = false
      }

      const json = await response.json()
      document.location.href = json.result.url

    },
    async getAvailablePlans(){
      const vm = this
      if(!vm.currentProvider) return
      vm.loading = true
      const response = await ApiUtils.makeGet(`subscriptions/plans/${vm.currentProvider.id}`)
      vm.loading = false

      if(response.ok){
        const json = await response.json()
        vm.plans = json.result.plans.data
      }

    }
  }
}
</script>

<style scoped>

</style>
